$(document).on('turbolinks:load', function () {
    let body = $(document.body)
    let firstFiveActivities = $(".activity-row").slice(0, 5)
    let activityCard = $(".activity-card")

    $(document).on('click', '.pitch-video .video-container', function (e) {
        modal = document.getElementById("video-modal");
        if (modal) {
            modal.style.display = "flex";
        }
    });

    $(document).on('click', '#campaign_video .video-container', function (e) {
        modal = document.getElementById("video-modal");
        if (modal) {
            modal.style.display = "flex";
        }
    });

    $(document).on('click', '#campaign_video .video-container', function (e) {
        var videoElement = $(this).find('video')[0];
        if (videoElement.paused) {
            videoElement.play();
            $(this).find("#play-final-video").hide();
        } else {
            $(this).find("#play-final-video").show();
            videoElement.pause();
        }
    });

    $(document).on('click', '#student_video .video-container', function (e) {
        var videoElement = $(this).find('video')[0];
        if (videoElement.paused) {
            videoElement.play();
            $(this).find("#play-final-video1").hide();
        } else {
            $(this).find("#play-final-video1").show();
            videoElement.pause();
        }
    });
    $(document).on('click', '#pending-video .video-container', function (e) {
        var videoElement = $(this).find('video')[0];
        if (videoElement.paused) {
            videoElement.play();
            $(this).find("#play-final-video2").hide();
        } else {
            $(this).find("#play-final-video2").show();
            videoElement.pause();
        }
    });

    $('.close-button').on('click', function () {
        let modal = $(this).parent().closest('div.v2-modal')
        modal.hide()
        body.css('overflow', 'auto')
    })

    firstFiveActivities.addClass('show')


    $("#load-more-activities").on('click', function () {
        let lastShownElement = $(".activity-row.show").last()
        setTimeout(function () {
            if ($(".activity-row:last").hasClass("show")) {
                $(".see-more-action").hide()
            }
        }, 10)

        lastShownElement.nextAll().slice(0, 5).addClass("show")
        if ($(".activity-row.show:visible").length > 5) {
            $(".activity-card").css('overflow-y', 'scroll')
        }
    })

    if(activityCard.height() >= 535){
        activityCard.css('max-height', '535px')
        activityCard.css('overflow-y', 'scroll')
    }
})
